/*
 * @Description: 登录路由
 */
import { RouteRecordRaw } from 'vue-router'
const loginRouter: Array<RouteRecordRaw> = [
	{
		path: '/login',
		component: () => import(/* webpackChunkName: "Login" */ '@/views/login/index.vue'),
        name: 'Login',
        meta: { title: '系统登录' }
		
	}
]

export default loginRouter
